import { CartAlertToaster, Img } from "components";
import Account from "./Account";
import DeliveryMode from "./DeliveryMode";
import DeliveryDateTime from "./DeliveryDateTime";
import Payment from "./Payment";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getOrderData } from "redux/reducers/orderData";

const STEPS = {
  ACCOUNT: 1,
  DELIVERY: 2,
  DATETIME: 3,
  PAYMENT: 4,
};

const CartProductStep = (props) => {
  const {
    // orderData,
    cartData,
    addressList,
    zoneList,
    occasionOptions,
    prepTime,
    cartItemError,
    isEventSent,
    setIsEventSent,
    sendCheckoutGaEvent,
  } = props;

  const [cartAlreatToast, setCartAlreatToast] = useState(false);
  const [activeStep, setActiveStep] = useState(STEPS.ACCOUNT);
  const orderData = useSelector(getOrderData);

   useEffect(() => {
    if (orderData?.accountForm === "completed") {
      if (orderData?.pageStep === 4) {
        setActiveStep(STEPS.PAYMENT);
      } else if (orderData?.pageStep === 3) {
        setActiveStep(STEPS.DATETIME);
      } else if (orderData?.delivery_mode) {
        setActiveStep(STEPS.DATETIME);
      } else {
        setActiveStep(STEPS.DELIVERY);
      }
    } else {
      setActiveStep(STEPS.ACCOUNT);
    }
  }, [orderData?.accountForm, orderData?.delivery_mode, orderData?.pageStep])

   const isStepVisible = (step) => {
    switch (step) {
      case STEPS.ACCOUNT:
        return orderData?.accountForm !== "completed";
        
      case STEPS.DELIVERY:
      return (
        orderData?.accountForm === "completed" &&
        (!orderData?.delivery_mode || orderData?.pageStep === 2)
      );
        
      case STEPS.DATETIME:
      return (
        orderData?.accountForm === "completed" &&
        orderData?.delivery_mode &&
        orderData?.delivery_mode !== "buying_for_love" &&
        orderData?.pageStep === 3
      );
        
      case STEPS.PAYMENT:
        if (orderData?.delivery_mode === "buying_for_love") {
          return (
            orderData?.accountForm === "completed" && 
            orderData?.delivery_mode &&
            orderData?.pageStep === 4
          );
        }
        return (
          orderData?.accountForm === "completed" &&
          orderData?.delivery_mode &&
          orderData?.pageStep === 4
        );
        
      default:
        return false;
    }
  };
  const isCompleted = (stepId) => {
    switch (stepId) {
      case STEPS.ACCOUNT:
        return orderData?.accountForm === "completed";

      case STEPS.DELIVERY:
        return !!orderData?.delivery_mode;

      case STEPS.DATETIME:
        return (
          orderData?.pageStep >= 4 &&
          orderData?.deliveryDateTimeActiveTab !== undefined
        );

      case STEPS.PAYMENT:
        return false;

      default:
        return false;
    }
  };

  return (
    <div
      className="relative flex flex-col flex-1 w-full gap-y-8 ltr:md:pl-7 rtl:md:pr-7 sm:order-2"
      onClick={(e) => {
        if (cartItemError) {
          setCartAlreatToast(true);
          setTimeout(() => {
            setCartAlreatToast(false);
          }, [6000]);
        }
      }}
    >
      {cartAlreatToast && cartItemError ? (
        <CartAlertToaster setCartAlreatToast={setCartAlreatToast} />
      ) : (
        ""
      )}
      <div className={cartItemError ? `pointer-none` : "no-error-in-cart-items"}>
  
  {/* SINGLE CART */}
  <div className="bg-white-A700 rounded-md shadow-sm overflow-hidden">

    {/* TOP STEPPER (INSIDE CART) */}
    <div className="px-6 py-4 border-b border-gray-200">
      <div className="relative flex items-center justify-between">

        {/* background line */}
        <div className="absolute top-[28px] left-6 right-6 h-[2px] bg-gray-200" />

        {/* active line */}
        <div
          className="absolute top-[28px] left-6 h-[2px] bg-[#771237] transition-all duration-300"
          style={{
            width:
              activeStep === STEPS.ACCOUNT
                ? "0%"
                : activeStep === STEPS.DELIVERY
                ? "33%"
                : activeStep === STEPS.DATETIME
                ? "66%"
                : "100%",
          }}
        />

        {[
          { id: STEPS.ACCOUNT, label: "Account", icon: "images/check.svg" },
          { id: STEPS.DELIVERY, label: "Delivery", icon: "images/mapLocation.png" },
          { id: STEPS.DATETIME, label: "Date & Time", icon: "images/dateTime.png" },
          { id: STEPS.PAYMENT, label: "Payment", icon: "images/cartPayment.png" },
        ].map((step) => {
          const completed = isCompleted(step.id);
          const isActiveOrDone = completed || activeStep === step.id;

          return (
            <div
              key={step.id}
              onClick={() => {
                if (step.id <= activeStep) {
                  setActiveStep(step.id);
                }
              }}
              className="relative z-10 flex flex-col items-center cursor-pointer"
            >
              {/* ICON WRAPPER */}
              <div
                className={`flex items-center justify-center rounded-full transition-all
                  ${
                    isActiveOrDone
                      ? "bg-[#771237]"
                      : "bg-white border border-gray-300"
                  }`}
                style={{
                  width: isActiveOrDone ? "56px" : "48px",
                  height: isActiveOrDone ? "56px" : "48px",
                  padding: isActiveOrDone ? "11.2px" : "8px",
                }}
              >
                <Img
                  src={completed ? "images/check.svg" : step.icon}
                  alt={step.label}
                  className="w-[32px] h-[32px] flex-shrink-0"
                />
              </div>

              {/* LABEL */}
              <span
                className={`mt-2 text-xs font-medium
                  ${
                    isActiveOrDone ? "text-[#771237]" : "text-gray-400"
                  }`}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>

        {isStepVisible(STEPS.ACCOUNT) && (
        <div className="relative bg-white-A700 py-[18px] px-6 xs:px-4">
          {/* <div className="absolute bg-red-100 flex h-9 items-center justify-center -left-7 rtl:-left-[auto] rtl:-right-7 p-1.5 top-6 w-9 z-[1] step-icon active">
            <Img className="h-6" src="images/person.svg" alt="user" />
          </div> */}
          <div className="absolute border-l-2 mt-2 border-gray-300 border-dashed w-px -left-3 rtl:-left-[auto] rtl:-right-3 z-[0] step-line success"></div>
          <Account addressList={addressList} />
        </div>
        )}
        {isStepVisible(STEPS.DELIVERY) && (
        <div className="relative bg-white-A700 py-[18px] px-6 xs:px-4">
          {/* <div className="absolute bg-white-A700 flex h-9 items-center justify-center -left-7 rtl:-left-[auto] rtl:-right-7 p-1.5 top-6 shadow-bs6 w-9 z-[1] step-icon active">
            <Img className="h-6" src="images/location_on.svg" alt="location" />
          </div> */}
          <div className="absolute border-l-2 mt-2 border-gray-300 border-dashed w-px -left-3 rtl:-left-[auto] rtl:-right-3 z-[0] step-line"></div>
          <DeliveryMode
            addressList={addressList}
            zoneList={zoneList}
            occasionOptions={occasionOptions}
            isEventSent={isEventSent}
            setIsEventSent={setIsEventSent}
            sendCheckoutGaEvent={sendCheckoutGaEvent}
          />
        </div>
        )}
        
        {isStepVisible(STEPS.DATETIME) && orderData?.delivery_mode !== "buying_for_love" && (
          <div className="relative bg-white-A700 py-[18px] px-6 xs:px-4">
            {/* <div className="absolute bg-white-A700 flex h-9 items-center justify-center -left-7 rtl:-left-[auto] rtl:-right-7 p-1.5 top-6 shadow-bs6 w-9 z-[1] step-icon">
              <Img className="h-6" src="images/event_note.svg" alt="calendar" />
            </div> */}
            <div className="absolute border-l-2 mt-2 border-gray-300 border-dashed w-px -left-3 rtl:-left-[auto] rtl:-right-3 z-[0] step-line"></div>
            <DeliveryDateTime orderDetails={cartData} prepTime={prepTime} />
          </div>
        )}
      
        {isStepVisible(STEPS.PAYMENT) && (
        <div className="relative bg-white-A700 pt-[18px]">
          {/* <div className="absolute bg-white-A700 flex h-9 items-center justify-center -left-7 rtl:-left-[auto] rtl:-right-7 p-1.5 top-6 shadow-bs6 w-9 z-[1] step-icon">
            <Img
              className="h-6"
              src="images/account_balance_wallet.svg"
              alt="camera"
            />
          </div> */}
          <Payment
            cartData={cartData}
            isEventSent={isEventSent}
            setIsEventSent={setIsEventSent}
            sendCheckoutGaEvent={sendCheckoutGaEvent}
          />
        </div>
        )}
      </div>
    </div>
    </div>
  );
};

export default CartProductStep;
